import React from "react";
import {OrderByType} from "@/services/context/project-order-by/models/order-by-type.ts";

export interface ProjectOrderByContextProps {
    orderBy: OrderByType;
    setOrderBy: (orderBy: OrderByType) => void;
}

export const ProjectOrderByContext = React.createContext<ProjectOrderByContextProps | undefined>(undefined);